import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from '../dashboard.service';
import { RemarkModel } from '../Models/remark.model';
import { SiteloaderComponent } from 'app/auth/siteloader/siteloader.component';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'app/shared/language.service';
import { AuthService } from 'app/auth/auth.service';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
export interface DialogData {
  id: string;
  userid: number;
}

@Component({
  selector: 'app-remarks',
  templateUrl: './remarks.component.html',
  styleUrls: ['./remarks.component.scss']
})
export class RemarksComponent implements OnInit {
  destroyremarks$: Subject<boolean> = new Subject<boolean>();
  //remarks_ds: MatTableDataSource<PastHistoryModel>
  private loaderdialog;

  remarks_ds: MatTableDataSource<RemarkModel>

  displayedColumns_remarks: string[] = ['Remark', 'Date', 'From', 'Action'];
  selectedLanguage: string;

  constructor(private dialogRef: MatDialogRef<RemarksComponent>,
    private dashboardService: DashboardService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private langservice: LanguageService,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) private data: DialogData) {
   dialogRef.disableClose = true;
   translate.addLangs(['en', 'fr', 'hi']);
   if (this.langservice.setlang) {
     translate.setDefaultLang(this.langservice.setlang);
   }
   else {
     translate.setDefaultLang('en');
   }
   this.getchangedlanguage();
  }
  getchangedlanguage(){
    this.translate.get(['remarkValidMsg.msg1','remarkValidMsg.msg2','remarkValidMsg.msg3','remarkValidMsg.msg4','remarkValidMsg.msg5','remarkValidMsg.msg6','remarkValidMsg.msg7','Ok']).subscribe(x=>{
      this.authService.RemarkvalidationMsg={};
      this.authService.RemarkvalidationMsg = x ;    

    })
  }

  ngOnInit() {
    this.dashboardService.allremarks=[];
    this.dashboardService.addremark={};
   // this.remarks_ds = new MatTableDataSource(this.dashboardService.allremarks.slice().reverse());
   this.getallremarks();
  }
  ngOnDestroy() {
    this.destroyremarks$.next(true);
    this.destroyremarks$.unsubscribe();
    this.dashboardService.allremarks=null;
    this.dashboardService.addremark=null;
  }
  switchLang(lang: string) {
    this.selectedLanguage = lang;
    //console.log('selectedLanguage',this.selectedLanguage)
    this.langservice.switchLang(lang);
    this.getchangedlanguage();
  }
  addremark(event) {
    this.open_loader_Dialog();
    if(event != "" ){      
      //this.dashboardService.showspinner = true saaf;
    //  this.dashboardService.addremark.UserName =this.dashboardService.
      this.dashboardService.addremark.PkOpdremarksId=0;
      this.dashboardService.addremark.userName=this.dashboardService.patientname;
      
      this.dashboardService.add_dashboard_remark().pipe(takeUntil(this.destroyremarks$)).subscribe(
        data => this.successremark(data), err => this.failedremark(err) )
    }else{
      this.dashboardService.openSnackBar(this.authService.RemarkvalidationMsg['remarkValidMsg.msg1'], this.authService.RemarkvalidationMsg['Ok']);
      this.loaderdialog.close();
    }
  }  

  Updateremark(remarkid:any ,event:any) { 
    this.dashboardService.addremark.userName=this.dashboardService.patientname;
    this.dashboardService.addremark.Remarks=event;
    this.dashboardService.addremark.PkOpdremarksId=remarkid;
   
    //this.dashboardService.showspinner = true saaf;
    this.open_loader_Dialog();
    this.dashboardService.add_dashboard_remark().pipe(takeUntil(this.destroyremarks$)).subscribe(
      data => this.successupdateremark(data), err => this.failedremark(err) )
  }
  open_loader_Dialog(): void {

    this.loaderdialog = this.dialog.open(SiteloaderComponent, {
      width: '300px',
      panelClass: 'site-loader',
      data: {
        // id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      }
    });

    this.loaderdialog .afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      //pid = result;
    });
  }
  successupdateremark(data) {
    this.dashboardService.openSnackBar(this.authService.RemarkvalidationMsg['remarkValidMsg.msg2'], this.authService.RemarkvalidationMsg['Ok']);
    this.dashboardService.addremark = {};
   this.getallremarks();
    }
  successremark(data) {
    this.dashboardService.openSnackBar(this.authService.RemarkvalidationMsg['remarkValidMsg.msg3'], this.authService.RemarkvalidationMsg['Ok']);
    this.dashboardService.addremark = {};
   // this.dialogRef.close();
    //this.dialog.closeAll();
   this.getallremarks();

  //  this.remarks_ds = new MatTableDataSource(this.dashboardService.allremarks.slice());
    }
    failedremark(err) {
      this.dashboardService.openSnackBar(this.authService.RemarkvalidationMsg['remarkValidMsg.msg4'], this.authService.RemarkvalidationMsg['Ok']);
      this.dashboardService.addremark = {};
    }

    getallremarks(){
      
      this.dashboardService.get_dashboard_remark().pipe(takeUntil(this.destroyremarks$)).subscribe(
        data => this.successremark_all(data), err => this.failedremark_all(err))
    }

    successremark_all(data) {
      this.dashboardService.allremarks = data;
      this.remarks_ds = new MatTableDataSource(this.dashboardService.allremarks.slice().reverse());
     //this.dashboardService.showspinner = false; 
     this.loaderdialog.close();
     
        }
        failedremark_all(err) {
          if(err.status==403){
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }else{
            this.dashboardService.openSnackBar(this.authService.RemarkvalidationMsg['remarkValidMsg.msg5'], this.authService.RemarkvalidationMsg['Ok']);
          } 
        }

  deleteremark(remarkid: number) {
   // this.dashboardService.showspinner = false;
    this.dashboardService.delete_dashboard_remark(remarkid).pipe(takeUntil(this.destroyremarks$)).subscribe(
      data => this.successremark_delete(data), err => this.failedremark_delete(err)
    )
  }

  successremark_delete(data) {
    this.dashboardService.openSnackBar(this.authService.RemarkvalidationMsg['remarkValidMsg.msg6'], this.authService.RemarkvalidationMsg['Ok']);
    this.getallremarks();
    }
    failedremark_delete(err) {
      if(err.status==403){
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }else{
        this.dashboardService.openSnackBar(this.authService.RemarkvalidationMsg['remarkValidMsg.msg7'], this.authService.RemarkvalidationMsg['Ok']);
      }   
    }

  closedialog(): void {
    this.dialogRef.close();
  }
  disCountHelplist(type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',
      data: {
        parametertype: type
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroyremarks$)).subscribe(result => {
      if (result != 0) {
        this.dashboardService.addremark.Remarks = result;
       
      }
    });
  }

}
